var map = {
	"./de.ts": 1261,
	"./en.ts": 1264,
	"./es_ES.ts": 1278,
	"./fr.ts": 1281,
	"./it.ts": 1284,
	"./ja.ts": 1287,
	"./ko.ts": 1290,
	"./ru.ts": 1293,
	"./tr.ts": 1296,
	"./vi.ts": 1299,
	"./zh.ts": 1302,
	"./zh_HK.ts": 1305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1260;